import styled, { css, keyframes } from 'styled-components';

import { colours } from 'themes/default';

const slideDown = keyframes`
  0% {
    top: -90%;
  }
  100% {
    top: 80px;
  }
`;

const fadeIn = keyframes`
  0% {
    background-color: rgba(200, 200, 200, 0);
  }
  100% {
    background-color: rgba(200, 200, 200, .5);
  }
`;

const PopupWrapper = styled.div`
  ${({ isOpen }) =>
    isOpen
      ? css`
          animation: 0.3s ${fadeIn} ease-out;
        `
      : css`
          display: none;
        `} position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(200, 200, 200, 0.5);
`;

const Popup = styled.div`
  z-index: 1001;
  height: 80%;
  width: calc(100% - 275px);
  max-width: 600px;
  background-color: ${colours.Greyscale.White};
  position: absolute;
  top: 80px;
  left: 30px;
  border-radius: 5px;
  padding: 5px;

  ${({ isOpen }) =>
    isOpen
      ? css`
          animation: 0.3s ${slideDown} ease-out;
        `
      : css`
          display: none;
        `}
`;

const VonageForm = styled.form`
  display: none;
`;

const VonageIFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const PaymentLoadingOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.5);
`;

export { Popup, PopupWrapper, VonageForm, VonageIFrame, PaymentLoadingOverlay };
